// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2GA7o","info":"UpdateTermsInfo_info__ad2Nx"};